var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 4.47716 14.4772 0 20 0H60L90 30V90C90 95.5228 85.5228 100 80 100H20C14.4772 100 10 95.5228 10 90V10Z",
    fill: "#444CE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60 0L90 30H70C64.4772 30 60 25.5228 60 20V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6666 51.6667L49.8074 47.9482C49.2723 46.878 49.0047 46.3429 48.6055 45.9519C48.2526 45.6062 47.8271 45.3433 47.36 45.1822C46.8319 45 46.2336 45 45.0371 45H38.6666C36.7997 45 35.8663 45 35.1533 45.3633C34.5261 45.6829 34.0161 46.1928 33.6966 46.82C33.3333 47.5331 33.3333 48.4665 33.3333 50.3333V51.6667M33.3333 51.6667H58.6666C61.4668 51.6667 62.867 51.6667 63.9365 52.2116C64.8773 52.691 65.6423 53.4559 66.1216 54.3967C66.6666 55.4663 66.6666 56.8664 66.6666 59.6667V67C66.6666 69.8003 66.6666 71.2004 66.1216 72.27C65.6423 73.2108 64.8773 73.9757 63.9365 74.455C62.867 75 61.4668 75 58.6666 75H41.3333C38.533 75 37.1329 75 36.0633 74.455C35.1225 73.9757 34.3576 73.2108 33.8782 72.27C33.3333 71.2004 33.3333 69.8003 33.3333 67V51.6667Z",
    stroke: "white",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLg);
export default __webpack_public_path__ + "static/media/default-lg.97cd28cc00f7d652e0b24a96a71e9088.svg";
export { ForwardRef as ReactComponent };